<template>
  <v-row>
    <v-col
      lg="6"
      md="8"
      sm="8"
      xs="12">
      <app-widget :title="$t('settings.title')">
        <v-form
          slot="widget-content"
          ref="settingsForm"
          v-model="valid"
          lazy-validation
          data-cy="settingsForm"
          @submit.prevent="submitSettingsForm"
        >
          <v-text-field
            data-cy="defaultDeviceRefreshRate"
            type="number"
            v-model.number="settings.defaultDeviceRefreshRate"
            :rules="validationRules.defaultRefreshRate"
            :label="`${$t('settings.fields.defaultRefreshRate')} *`"
            required/>
          <v-text-field
            data-cy="sendDeviceToTransfereeNotificationDays"
            type="number"
            v-model.number="settings.sendDeviceToTransfereeNotificationDays"
            :rules="validationRules.sendDeviceNotificationDays"
            :label="`${$t('settings.fields.sendDeviceNotificationDays')} *`"
            required/>
          <v-text-field
            data-cy="deviceNotReturnedNotificationDays"
            type="number"
            v-model.number="settings.deviceNotReturnedNotificationDays"
            :rules="validationRules.deviceNotReturnedNotificationDays"
            :label="`${$t('settings.fields.deviceNotReturnedNotificationDays')} *`"
            required/>
          <v-text-field
            data-cy="maxLocationNumber"
            type="number"
            v-model.number="settings.maxLocationNumber"
            :rules="validationRules.maxLocationNumber"
            :label="`${$t('settings.fields.maxLocationNumber')} *`"
            required/>
          <div class="pt-10">
            <v-btn
              data-cy="submitBtn"
              type="submit"
              color="success"
              :loading="loadingSettings"
              class="mr-4"
            >
              {{ $t('common.form.save') }}
            </v-btn>
            <v-btn
              data-cy="cancelBtn"
              color="default"
              :to="routeConstants.DASHBOARD_URL"
            >
              {{ $t('common.form.cancel') }}
            </v-btn>
          </div>
        </v-form>
      </app-widget>
    </v-col>
  </v-row>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import AppWidget from '@/components/widgets/AppWidget';
  import * as routeConstants from '@/router/constants';
  import * as actions from '@/store/actions.type';
  import {
    NOTIFICATION_ERROR,
    NOTIFICATION_SUCCESS
  } from '@/common/event.types';

  export default {
    name: 'Settings',
    data: () => ({
      routeConstants: routeConstants,
      valid: true,
    }),
    components: {
      AppWidget,
    },
    computed: {
      ...mapGetters([
        'settings',
        'loadingSettings',
      ]),
      validationRules() {
        return {
          defaultRefreshRate: [
            v => !!v || this.$t('validationMessages.settings.defaultRefreshRate.required'),
            v => (v === '' || (v >= 1 && v <= 24)) ||
              this.$t('validationMessages.settings.defaultRefreshRate.valueBetween', {max: 24, min: 1}),
          ],
          sendDeviceNotificationDays: [
            v => !!v || this.$t('validationMessages.settings.sendDeviceNotificationDays.required'),
            v => (v === '' || (v > 0 && v < 6000)) ||
              this.$t('validationMessages.settings.sendDeviceNotificationDays.valueBetween', {max: 6000, min: 1}),
          ],
          deviceNotReturnedNotificationDays: [
            v => !!v || this.$t('validationMessages.settings.deviceNotReturnedNotificationDays.required'),
            v => (v === '' || (v > 0 && v < 6000)) ||
              this.$t('validationMessages.settings.deviceNotReturnedNotificationDays.valueBetween',
                {max: 6000, min: 1}),
          ],
          maxLocationNumber: [
            v => !!v || this.$t('validationMessages.settings.maxLocationNumber.required'),
            v => (v === '' || (v >= 2 && v <= 32767)) ||
              this.$t('validationMessages.settings.maxLocationNumber.valueBetween',
                {max: 32767, min: 2}),
          ],
        };
      },
    },
    mounted() {
      this.getCurrentSettingsAction();
    },
    methods: {
      ...mapActions({
        getCurrentSettingsAction: actions.GET_CURRENT_SETTINGS,
        saveSettingsAction: actions.SAVE_SETTINGS,
      }),
      submitSettingsForm() {
        if (this.$refs.settingsForm.validate()) {
          this.saveSettingsAction(this.settings).then(() => {
            this.$router.push(routeConstants.DASHBOARD_URL);
            this.$eventHub.$emit(NOTIFICATION_SUCCESS, {
              message: this.$t('settings.alerts.settingsSuccessfullySaved'),
            });
          }).catch(({data}) => {
            this.$eventHub.$emit(NOTIFICATION_ERROR, {
              message: data,
            });
          });
        }
      },
    },
  };
</script>
